import { ThemeOptions } from '@mui/material';
import { defaultTheme } from 'react-admin';

export type ThemeMode = 'light' | 'dark' | 'system';

export const THEME_MODES: { mode: ThemeMode; label: string }[] = [
  { mode: 'light', label: 'Light' },
  { mode: 'dark', label: 'Dark' },
  { mode: 'system', label: 'System' }
];

/** The store key the chosen mode lives under; react-admin keeps its store in localStorage. */
export const THEME_MODE_KEY = 'themeMode';

export const lightTheme: ThemeOptions = defaultTheme as ThemeOptions;

// react-admin's default tints filled inputs with black, which vanishes on a dark page.
export const darkTheme: ThemeOptions = {
  ...lightTheme,
  palette: {
    mode: 'dark',
    primary: { main: '#90caf9' },
    secondary: { light: '#9be7ff', main: '#64b5f6', dark: '#2286c3', contrastText: '#000' },
    background: { default: '#121212', paper: '#1e1e1e' }
  },
  components: {
    ...lightTheme.components,
    MuiFilledInput: {
      styleOverrides: {
        root: {
          backgroundColor: 'rgba(255, 255, 255, 0.09)',
          '&.Mui-disabled': { backgroundColor: 'rgba(255, 255, 255, 0.12)' }
        }
      }
    },
    // The app bar keeps the brand's blue in the light theme; in the dark one it sits on the paper colour like the rest.
    MuiAppBar: { styleOverrides: { colorSecondary: { backgroundColor: '#272727', color: '#fff' } } },
    // react-admin paints the "N items selected" bar with primary.dark, a mid blue the red Delete vanished on.
    RaBulkActionsToolbar: { styleOverrides: { root: { '& .RaBulkActionsToolbar-toolbar': { backgroundColor: '#263238' } } } }
  } as ThemeOptions['components']
};

/** The theme a mode stands for; "system" follows the operating system's setting. */
export const themeFor = (mode: ThemeMode, systemPrefersDark: boolean): ThemeOptions => (mode === 'dark' || (mode === 'system' && systemPrefersDark) ? darkTheme : lightTheme);
